<template>

  <form @submit="submit($event)">

    <alert ref="alert"/>

    <div class="form-group" v-if="showForm">
      <label class="sr-only" for="inputPassword">{{ _translate('lblEmail') }}</label>
      <input
        v-model="email"
        type="email"
        class="form-control"
        v-bind:class="{'is-invalid': errors.email}"
        id="inputPassword"
        name="email"
        v-bind:placeholder="_translate('lblEmail')"
        @keyup.enter="submit($event)">
      <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
    </div>

    <button @click="submit($event)" v-if="showForm" type="button" class="btn btn-primary btn-block">{{ _translate('lblSend') }}</button>
  </form>

</template>

<script>
import alert            from '../alert'
import Qs               from 'query-string'
import { http }         from '@/http'
import StaticTranslator from './../../../model/translator/StaticTranslator'

export default {
  components: { alert },
  props:      ['parentEmail'],
  data () {
    return {
      email:      this.parentEmail,
      showForm:   true,
      languageId: 1,

      errors: {
        email: null
      },

      translator: new StaticTranslator()
    }
  },
  methods:    {
    submit (e) {
      e.preventDefault()

      if (this.hasErrors()) {
        return
      }

      let callback = (latitude, longitude) => {
        let d = {
          email:       this.email,
          IdtLanguage: this.languageId
        }

        if (latitude && longitude) {
          d.CurrentLatitude  = latitude
          d.CurrentLongitude = longitude
        }

        let data = Qs.stringify(d)

        http.post(
          `User/SendVerifyEmail`,
          data,
          {
            headers: {
              'Content-type': 'application/x-www-form-urlencoded'
            }
          }
        )
          /* zpracovani pozadavku */
            .then(response => {
              let message = 'Požadavek byl odeslán'
              this.$refs.alert.showMessage({ message: message, type: 'success' })

              this.showForm = false
            })

            .catch(e => {
              let message = 'Požadavek se nepodařilo odeslat: (' + e.message + ')'
              this.$refs.alert.showMessage({ message: message, type: 'error' })
            })
      }

      navigator.geolocation.getCurrentPosition((position) => {
        let latitude  = position.coords.latitude,
            longitude = position.coords.longitude

        callback(latitude, longitude)
      }, () => {
        callback(null, null)
      })
    },

    /**
     *
     * @return {boolean}
     */
    hasErrors () {
      let hasError = false

      if (!this.email) {
        hasError          = true
        this.errors.email = 'Prosím zadejte email'
      }

      return hasError
    },

    /**
     *
     * @param text
     * @return {*}
     * @private
     */
    _translate (text) {
      return this.translator.translate(text)
    }
  }
}
</script>

<style scoped>

</style>
